// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"210":"triglav_vortec","695":"triglav_vortec_policy","854":"pdfjs"}[chunkId] || chunkId) + "." + {"124":"cec91704","210":"151deac0","695":"18655d68","854":"5554daa7"}[chunkId] + ".js";
};